import { resolveFieldType } from './inputTypeMapper';

export const extractPhotos = (fields) => {
  return fields
    .filter((field) => resolveFieldType(field.DataType) === 'Photo')
    .map((field) => ({
      name: field.Code,
      label: field.Label,
      description: field.Description || null,
      required: field.Required,
      exampleImage: field.AdditionalProps?.exampleImage || field.AdditionalProps?.ExampleImage || null,
    }));
};

export const groupFieldsBySection = (fields) => {
  const sections = {};

  fields.forEach((field) => {
    if (!field) {
      return;
    }

    const section = field.section || 'Other';
    if (!sections[section]) {
      sections[section] = [];
    }
    sections[section].push(field);
  });

  return sections;
};
